<template>
    <div class="reviews-item-answer">
        <div class="reviews-item-answer-member">
            <AAvatar
                width="50"
                :src="result.author_pic.src"
                :alt="result.author_pic.alt"
                :title="result.author_pic.title"
                class="reviews-item-answer-member__picture"/>
            
            <div>
                <h6 class="reviews-item-answer-member__name">
                    {{ result.author_name }}
                </h6>
                <time class="reviews-item-answer-member__date">
                    {{ result.date }}
                </time>
            </div>
        </div>
        <div class="reviews-item-answer-content">
            {{ result.text }}
        </div>
    </div>
</template>

<script>
import {AAvatar} from "~/components/ui";

export default {
    name: 'ReviewsItemAnswer',
    props: ['result'],
    components: {AAvatar}
}
</script>

<style lang="scss" scoped>
.reviews-item-answer {

}

.reviews-item-answer-member {
    display: grid;
    grid-template-columns: 50px 1fr;
    grid-column-gap: 12px;
    margin-bottom: 21px;

    &__picture {
        border-radius: 50%;
    }

    &__name {
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        color: #252425;
    }

    &__date {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #252425;
    }
}

.reviews-item-answer-content {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}
</style>